import { HreflangUrl } from '@/api/cms/cms';
import { SettingsResponse } from '@/generated/data.schemas';
import { Hreflang } from '@/routes/_head.partial';

export const getHreflangs = (
	hreflangUrls: HreflangUrl[] | undefined,
	settings: SettingsResponse | null | undefined,
): Hreflang[] | undefined => {
	const hreflangs: Hreflang[] = [];

	if (!hreflangUrls || hreflangUrls.length === 0 || !settings) {
		return undefined;
	}

	const targetUrls = hreflangUrls; //[...new Set(Array.isArray(content?.data?.url) ? content.data.url : [content?.data?.url])];
	const defaultSegmentation = settings?.segmentations?.find((x) => x.primaryPath === '');

	targetUrls.forEach((hreflangUrl) => {
		if (!hreflangUrl) return;

		const locale = getFirstPathSegmentFromPath(hreflangUrl.url);

		const segmentation = settings?.segmentations?.find((x) => x.primaryPath === locale) ?? defaultSegmentation;

		if (segmentation != null) {
			const hrefLang: Hreflang = {
				url: segmentation.baseUrl + hreflangUrl.url,
				language: segmentation.cultureCode,
			};

			hreflangs.push(hrefLang);
		}
	});

	const defaultHrefLang = hreflangs.find((x) => x.language === 'en-GB');
	if (defaultHrefLang) {
		hreflangs.push({ url: defaultHrefLang.url, language: 'x-default' });
	}

	return hreflangs;
};

function getFirstPathSegmentFromPath(path: string): string | null {
	const cleanPath = path.split('?')[0];
	const segments = cleanPath.split('/').filter(Boolean);
	return segments.length > 0 ? '/' + segments[0] : null;
}
